import React from "react";
import { Col, Row, ButtonGroup } from "reactstrap"; // Reactstrap components

import links from "../../../../static/assets-links.json";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

const { CompetitorBlack, CompetitorWhite, NextBrandBlack, NextBrandWhite } = links


const brandTabs = [
  {
    title: 'Already Working With',
    value: 'Already Working With',
    activeIcon: CompetitorWhite,
    InActiveIcon: CompetitorBlack,
  },
  {
    title: 'Matched By AI',
    value: 'Matched By AI',
    activeIcon: CompetitorWhite,
    InActiveIcon: CompetitorBlack,
  },
  {
    title: "Next To Brands",
    value: "Next To Brands",
    activeIcon: NextBrandWhite,
    InActiveIcon: NextBrandBlack,
  },
  {
    title: "Competitors",
    value: "Competitors",
    activeIcon: CompetitorWhite,
    InActiveIcon: CompetitorBlack,
  },
]

const retailerTabs = [
  {
    title: 'Already Working With',
    value: 'Already Working With',
    activeIcon: CompetitorWhite,
    InActiveIcon: CompetitorBlack,
  },
  {
    title: 'Matched By AI',
    value: 'Matched By AI',
    activeIcon: CompetitorWhite,
    InActiveIcon: CompetitorBlack,
  },
  {
    title: 'Retailers with similar profile',
    value: 'Similar Retailers',
    activeIcon: CompetitorWhite,
    InActiveIcon: CompetitorBlack,
  },
]

const ProfileInfoBrandTabs = ({ isLoading, selectedTab, onTabSelect }) => {
  const { type } = useParams();
  const theme = useSelector(state => state.layout?.company?.theme) || 'black';

  const tabsData = type === 'brand' ? brandTabs : retailerTabs;


  return (
    <Row
      style={{
        marginBottom: "20px",
        backgroundColor: "#F6F6F6",
        borderRadius: "8px",
        overflow: "hidden",
        opacity: isLoading ? 0.5 : 1,
        border: "1px solid #9D9D9D",
        justifyContent: "space-between",
      }}
    >
      {tabsData?.map(({ title, value, activeIcon, InActiveIcon }) => (
        <Col
          key={title}
          xs={6}
          style={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "16px",
            backgroundColor: selectedTab === value ? theme : "transparent",
            cursor: "pointer",
          }}
          onClick={() => !isLoading && onTabSelect(value)}
        >
          <ButtonGroup>
            <h5
              style={{
                fontSize: "16px",
                fontWeight: 500,
                color: selectedTab === value ? "#fff" : "#000",
              }}
            >
              {title}
            </h5>
          </ButtonGroup>
        </Col>
      ))}
    </Row>
  );
};

export default ProfileInfoBrandTabs;
